import AdminProfileSettings from "./AdminProfileSettings";
export default AdminProfileSettings;
